// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__SAbz2","item":"style_item__MNoH2","image":"style_image__T5lQ7","price":"style_price__6OWuK","name":"style_name__o4vA8","count":"style_count__EKY-0"};